export default __webpack_public_path__ + "static/media/july2024-4.c5ce8991.jpg";